// extracted by mini-css-extract-plugin
export default {"ConfirmationDialog_text":"webpack-pages-DataExtraction-ConfirmationDialog-module__ConfirmationDialog_text"};